import { apiClient } from "helpers/api_helper";
import { UpdateInventoryReturnDataIds } from "modules/inward/diamond-product-inventory/model";
import { UpdateInwardDataIds } from "modules/inward/diamond-product-inward/model/update-inword.model";

export const updateGoldAndDiamondInwardRecords = async (productHeaderIds: UpdateInwardDataIds) => {
    try {
        const response = await apiClient.post(`/api/v1/ProductDetails/UpdateSNMCCProductReceived`, productHeaderIds);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateGoldAndDiamondInventoryRecords = async (productHeaderIds: UpdateInventoryReturnDataIds) => {
    try {
        const response = await apiClient.post(`/api/v1/ReturnToMayave/InsertReturnToMayaveProduct`, productHeaderIds);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
